import React from "react";
import {Box, Button, Menu, MenuItem, Stack, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const options = [
    'Show some love to MUI',
    'Show all notification content',
    'Hide sensitive notification content',
    'Hide all notification content',
];

const SelectedMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };
    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setAnchorEl(null);
    };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
              Selected menu
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
              If used for item selection, when opened, simple menus places the initial focus on the selected menu item. The currently selected menu item is set using the selected prop (from ListItem). To use a selected menu item without impacting the initial focus, set the variant prop to "menu".
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>
      <PreviewAndEditor
        language="js"
        title={"Basic menu"}
        value={
          'import {Button, Menu, MenuItem } from "@mui/material";\n\n\n' +
            "const options = [\n" +
            "  'Show some love to MUI',\n" +
            "  'Show all notification content',\n" +
            "  'Hide sensitive notification content',\n" +
            "  'Hide all notification content',\n" +
            "];\n\n\n"+
            "  const [selectedIndex, setSelectedIndex] = React.useState(1);\n"+
          " const [anchorEl, setAnchorEl] = React.useState(null);\n" +
          "  const open = Boolean(anchorEl);\n" +
          "  const handleClickListItem = (event) => {\n" +
          "    setAnchorEl(event.currentTarget);\n" +
          "  };\n" +
            "const handleMenuItemClick = (event, index) => {\n" +
            "        setSelectedIndex(index);\n" +
            "        setAnchorEl(null);\n" +
            "    };"+
          "  const handleClose = () => {\n" +
          "    setAnchorEl(null);\n" +
          "  };\n\n\n" +
          "<Button\n" +
          '          id="basic-button"\n' +
          '          aria-controls={open ? "basic-menu" : undefined}\n' +
          '          aria-haspopup="true"\n' +
          '          aria-expanded={open ? "true" : undefined}\n' +
          "          onClick={handleClickListItem}\n" +
          "        >\n" +
          "          Dashboard\n" +
          "        </Button>\n" +
          "<Menu\n" +
            "            id=\"lock-menu\"\n" +
            "            anchorEl={anchorEl}\n" +
            "            open={open}\n" +
            "            onClose={handleClose}\n" +
            "            MenuListProps={{\n" +
            "              'aria-labelledby': 'lock-button',\n" +
            "              role: 'listbox',\n" +
            "            }}\n" +
            "        >\n" +
            "          {options.map((option, index) => (\n" +
            "              <MenuItem\n" +
            "                  key={option}\n" +
            "                  disabled={index === 0}\n" +
            "                  selected={index === selectedIndex}\n" +
            "                  onClick={(event) => handleMenuItemClick(event, index)}\n" +
            "              >\n" +
            "                {option}\n" +
            "              </MenuItem>\n" +
            "          ))}\n" +
            "        </Menu>"
        }
      >
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
        >
          Dashboard
        </Button>
        <Menu
            id="lock-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'lock-button',
              role: 'listbox',
            }}
        >
          {options.map((option, index) => (
              <MenuItem
                  key={option}
                  disabled={index === 0}
                  selected={index === selectedIndex}
                  onClick={(event) => handleMenuItemClick(event, index)}
              >
                {option}
              </MenuItem>
          ))}
        </Menu>
      </PreviewAndEditor>
    </Box>
      </Stack>
  );
};

export default SelectedMenu;
